//core modules
import React from "react";

//custom modules
import {useStepsContext} from "./context/stepsContext";
import Common from "../../Common/Common";
import SubscriptionContainer from "./SubscriptionContainer";

const Subscription = () => {

    const {showLoader,currentStep} = useStepsContext();

    return (
        <Common pageTitle={"Subscription"} mainContent={
            <SubscriptionContainer currentStep={currentStep} />
        } />
    );
}

export default Subscription;
